<div class="flex">
    <button mat-raised-button class="mat-button-small" color="primary" *ngIf="!isLoading" matTooltip="Setujui"
        matTooltipPosition="above" (click)="approve()">
        Setujui
    </button>
    <button mat-raised-button class="mat-button-small" color="warn" *ngIf="!isLoading" matTooltip="Tolak"
        matTooltipPosition="above" (click)="reject()">
        Tolak
    </button>
</div>